import { useCallback, useRef } from 'react';
const setRef = (ref, node)=>{
    if (typeof ref == 'function') ref(node);
    else if (ref != null) ref.current = node;
};
export const useMergedRefs = (...refs)=>{
    const latestRefs = useRef(refs);
    latestRefs.current = refs;
    return useCallback((node)=>{
        for (const ref of latestRefs.current)setRef(ref, node);
    }, []);
};
